<template>
    <Transition name="fade">
        <slot></slot>
        <!-- pass down slot content -->
    </Transition>
</template>

<script>
export default {
    name: 'FadeTransition',
};
</script>
